/**
 * Unified Query Keys for Waritto
 *
 * All query keys are centralized here to:
 * 1. Prevent typos and inconsistencies
 * 2. Enable type-safe cache invalidation
 * 3. Make refactoring easier
 */

// ==================== Groups ====================

export const groupKeys = {
  all: ["groups"] as const,
  detail: (groupId: string) => [...groupKeys.all, groupId] as const,
  members: (groupId: string) => [...groupKeys.detail(groupId), "members"] as const,
};

// ==================== Sessions ====================

export const sessionKeys = {
  all: ["sessions"] as const,
  group: (groupId: string) => [...sessionKeys.all, groupId] as const,
  detail: (groupId: string, sessionId: string) =>
    [...sessionKeys.group(groupId), sessionId] as const,
  images: (groupId: string, sessionId: string) =>
    [...sessionKeys.detail(groupId, sessionId), "images"] as const,
};

// ==================== Expenses ====================

export const expenseKeys = {
  all: ["expenses"] as const,
  session: (groupId: string, sessionId: string) =>
    [...expenseKeys.all, groupId, sessionId] as const,
  detail: (groupId: string, sessionId: string, expenseId: string) =>
    [...expenseKeys.session(groupId, sessionId), expenseId] as const,
  balances: (groupId: string, sessionId: string) =>
    [...expenseKeys.session(groupId, sessionId), "balances"] as const,
  settlements: (groupId: string, sessionId: string) =>
    [...expenseKeys.session(groupId, sessionId), "settlements"] as const,
};

// ==================== Payments ====================

export const paymentKeys = {
  all: ["payments"] as const,
  session: (groupId: string, sessionId: string) =>
    [...paymentKeys.all, groupId, sessionId] as const,
  settlementsWithPayments: (groupId: string, sessionId: string) =>
    ["settlements-with-payments", groupId, sessionId] as const,
};

// ==================== Balance ====================

export const balanceKeys = {
  summary: ["balance-summary"] as const,
  recentExpenses: (groupIds: string) => ["recentExpenses", groupIds] as const,
};

// ==================== Profile ====================

export const profileKeys = {
  paymentInfo: ["paymentInfo"] as const,
};
